import { GlobalToken } from 'antd';
import styled from 'styled-components';

import { CustomThemeToken } from '@/theme';

import { ContainerProps } from './NodeWidget.types';

export const Container = styled.div<ContainerProps>`
  ${({ $isDummy }: { $isDummy?: boolean }) => !$isDummy && 'cursor: pointer;'}
  margin: ${({ theme: { token } }) => token.marginXS}px;
  border: 2px solid ${({ theme: { token }, $isSelected }) => ($isSelected ? token.colorPrimary : 'transparent')};
  border-radius: 4px; /* Optional: to make the border look nicer */
  box-sizing: border-box;
`;

export const DetailsWidget = styled.div<{ theme: { token: GlobalToken } }>`
  .first-row {
    display: flex;
    height: 222px;
    width: 100%;

    .main-slider {
      width: 385px;
      height: 100%;
    }

    .next-service {
      width: 175px;
      height: 100%;
      padding: ${({ theme: { token } }) => token.paddingLG}px;
      border: 1px solid ${({ theme: { token } }) => token.colorBgElevated};

      .title {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        color: ${({ theme: { token } }) => token.colorTextTertiary};
        text-transform: uppercase;
      }

      .value {
        color: ${({ theme: { token } }) => token.colorText};
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .label {
        color: ${({ theme: { token } }) => token.colorTextSecondary};
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;
      }
    }
  }
`;

export const StyledModalContent = styled.div<{ theme: { token: CustomThemeToken } }>`
  display: flex;
  height: 94%;
  width: 100%;
  overflow-y: scroll;
  margin-top: ${({ theme: { token } }) => token.marginXS}px;

  .package-inactive-wrap {
    margin-left: ${({ theme: { token } }) => token.marginXL}px;
  }

  .label-detail {
    color: ${({ theme: { token } }) => token.colorText};
  }
  .wrap-labels {
    display: flex;
    gap: 5px;
    align-items: center;
  }
  .label-care-details {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
  }
  .care-details-wrap {
    display: flex;
    flex-direction: column;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    margin-left: ${({ theme: { token } }) => token.marginXL}px;
  }
  .circle-filled-enable {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px !important;
    color: ${({ theme: { token } }) => token.colorIR};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
  .check-circle-filled {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    color: ${({ theme: { token } }) => token.colorError};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    opacity: 0.9;
  }
  .main-title {
    display: grid;

    .device-title {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;

      .device-type {
        color: ${({ theme: { token } }) => token.colorTextSecondary};
        font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
      }
    }

    .seperator {
      width: 1px;
      border: 1px solid ${({ theme: { token } }) => token.colorText};
    }

    .subtitle {
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      height: 27px;
      margin: 0 ${({ theme: { token } }) => token.marginXXL}px ${({ theme: { token } }) => token.margin}px 0;
    }
  }

  .left {
    flex-grow: 1;
    padding-right: ${({ theme: { token } }) => token.paddingXS}px;

    header {
      .grid-area-5 {
        margin-top: ${({ theme: { token } }) => token.marginXL}px;
      }
    }
  }

  .right {
    flex-shrink: 0;
    width: 330px;
  }

  .icon-frame {
    display: flex;
    width: 310px;
    height: 222px;
    border: solid 1px ${({ theme: { token } }) => token.colorBgElevated};
    justify-content: center;
    align-items: center;
  }
`;
